// extracted by mini-css-extract-plugin
module.exports = {"webToCaseForm":"CreateCaseForm_webToCaseForm__p3ULj","reCaptchaFail":"CreateCaseForm_reCaptchaFail__puBYs"};